module.exports = __webpack_public_path__ + "img/gipi.641594a1.png";